import { render, staticRenderFns } from "./map-legend.vue?vue&type=template&id=49add5b1&"
import script from "./map-legend.vue?vue&type=script&lang=js&"
export * from "./map-legend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports